"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultMortgageCommonTranslate = void 0;
exports.defaultMortgageCommonTranslate = {
    mortgageRepaymentTitle: 'Mortgage Repayment',
    mortgageRepaymentCaption: 'Compare monthly payment for different mortgage plans.Compare monthly payment for different mortgage plans. Compare monthly payment for different mortgage plans. Compare monthly payment for different mortgage plans. Compare monthly payment for different mortgage plans. Compare monthly payment for different mortgage plans. ',
    affordabilityCalculatorTitle: 'Affordability Calculator (By Income)',
    affordabilityCalculatorCaption: 'Maximum property price can afford with stress test accounted',
    affordabilityByPaymentCalculatorTitle: 'Affordability Calculator (By Payment)',
    affordabilityByPaymentCalculatorCaption: 'Maximum property price can afford with fix payments you can repay monthly',
    refinanceTitle: 'Refinance Calculator',
    refinanceCaption: 'Cash out from your asset by switching to another mortgage plan',
    loanPercentage: 'Loan Percentage',
    loanPercentageHint: 'Amount you have to repay to bank',
    highestAffordableProperty: 'Highest Affordable Property',
    outstandingMortgage: 'Outstanding Mortgage',
    outstandingMortgageHint: 'Amount you have to repay to bank',
    currentTenor: 'Current Tenor',
    currentTenorHint: 'How many years left from your existing mortgage plan',
    exisitingInterestRate: 'Existing Interest Rate',
    exisitingInterestRateHint: 'Existing Interest rate (p.a.)',
    newPropertyValue: 'New Property Value',
    newPropertyValueHint: 'Latest Value of your property',
    newLoanAmount: 'New Loan Amount',
    newLoanAmountHint: 'Amount you want to loan in the new mortgage plan',
    newTenor: 'New Tenor',
    newTenorHint: 'Number of years you are going to repay (eg. 30 years)',
    newInterestRate: 'New Interest Rate',
    newInterestRateHint: 'Interest Rate (p.a) of new plan',
    newMortgagePlan: 'New Mortgage Plan',
    cashOut: 'Cash Out',
    totalInterest: 'Total Interest',
    existingMortgagePlan: 'Existing Mortgage Plan',
    compareMortgagePlans: 'Compare Mortgage Plans',
    newPlan: 'New Plan',
    existingPlan: 'Existing Plan',
    loanAmount: 'Loan Amount',
    loanAmountHint: 'Loan Amount',
    propertyValue: 'Property Value',
    propertyValueHint: 'Current Price of Property',
    hkd: 'HK$',
    downPayment: 'Down Payment',
    downPaymentHint: 'The amount you don\'t need to borrow',
    totalMortgage: 'Total Mortgage',
    totalMortgageHint: 'Mortgage: {}<br/>+<br/>Mortgage Insurance: {}',
    tenor: 'Tenor',
    years: 'Years',
    tenorHint: 'Duration of loan in years (eg. 30 years)',
    interestRate: 'Interest Rate',
    interestRateHint: 'Interest rate the bank (p.a.)',
    nonCorporate: 'I am an HK Resident and non-corporate buyer',
    nonFirstTime: 'I currently own a property in Hong Kong',
    hasOutstandingMortgage: 'I have outstanding mortgage in Hong Kong',
    hasTransactedRecently: 'This property has transacted within',
    hasTransactedRecentlyHint: 'Special Stamp Duty (SSD) is payable (10% to 20%) when there is a resale or transfer of the property within 36 months',
    month: 'Months',
    calculate: 'Calculate',
    overview: 'Overview',
    schedule: 'Schedule',
    rateTable: 'Rate Table',
    monthlyPayment: 'Monthly Payment',
    monthlyPaymentHint: 'Amount you can pay monthly',
    monthlyIncome: 'Monthly Income',
    monthlyIncomeHint: 'Monthly income in HKD',
    minimumIncome: 'Minimum Income',
    totalExpensesBreakdown: 'Total Expenses Breakdown',
    totalCashOutlay: 'Total Cash Outlay',
    mortgage: 'Mortgage',
    interest: 'Interest',
    insurance: 'Insurance',
    stampDuty: 'Stamp Duty',
    commission: 'Commission',
    legal: 'Legal',
    total: 'Total',
    monthlyExpenses: 'Monthly Expenses',
    totalExpenses: 'Total Expenses',
    principle: 'Principle',
    initialTotalCashOutlay: 'Initial Total Cash Outlay',
    stressTest: 'Stress Test',
    stressTestRateIncreaseHint: '(Stress test) Assumed if interest rate is raised by 3% based on the current LTV ratio',
    assumedInterestRate: 'Assumed Interest Rate',
    searchLabel: 'Let us do the search for you',
    searchTitle: 'Looking properties for',
    view: 'View',
    listings: 'Listings',
    learnMoreAboutMortgage: 'Learn more about Mortgage',
    resources: 'Resources',
    mortgageCalculator: 'Mortgage Calculator',
    affordability: 'Affordability',
    refinancing: 'Refinancing',
    learnMore: 'Learn More',
    mortgageSummary: 'Mortgage Summary',
    noMonth: '# Month',
    payment: 'Payment',
    balance: 'Balance',
    year: 'Year',
    unlimited: 'Unlimited',
    below: 'below',
    above: 'above',
    disclaimer: 'DISCLAIMER: The calculated value is based on assumptions and provides an approximate result for your reference only.',
    error: 'Error',
    errorTooMuchLoanPercent: 'No mortgage plans available, maximum loan percent is {}%',
    errorTooMuchLoanAmount: 'No mortgage plans available, maximum loan amount is ${}',
    errorMinDownPaymentAmount: 'No mortgage plans available, minimum down payment amount is ${}',
    errorExceedTenor: 'No mortgage plans available, maximum tenor is {} years',
    errorUnknown: 'No mortgage plans available'
};
